<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline primary"
          primary-title
          style="color:#fff"
        >
          Notes on Audit Failure
        </v-card-title>

        <v-card-text>
          {{remarkText}}
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions style="flex-direction: row-reverse;">
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            text
            @click="dialog=false"
          >
            Agree
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data: () => ({
    dialog: false
  }),
  props: ['remarkText', 'isRemark'],
  watch: {
    isRemark () {
      this.dialog = true
      this.$emit('myevent')
    }
  }

}
</script>
